import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import HrnbContainer, { HrnbRow, HrnbCol } from "../controls/HrnbContainer";
import HrnbInput from "../controls/HrnbInput";
import HrnbButton from "../controls/HrnbButton";
import { SearchIcon, ClearIcon } from "../../icons";

export default function HrnbSearch({
                                       value: controlledValue,
                                       onChange,
                                       onSearch,
                                       placeholder = "Поиск...",
                                       debounceMs = 300,
                                       showClear = true,
                                       buttonText = "Найти",
                                       className = "",
                                   }) {
    const isControlled = typeof controlledValue === "string";
    const [value, setValue] = useState(controlledValue ?? "");
    const [debounced, setDebounced] = useState(value);

    // sync controlled prop -> internal state
    useEffect(() => {
        if (isControlled) setValue(controlledValue);
    }, [controlledValue, isControlled]);

    // debounce
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), debounceMs);
        return () => clearTimeout(t);
    }, [value, debounceMs]);

    // call onSearch when debounced value changed
    useEffect(() => {
        if (typeof onSearch === "function") onSearch(debounced);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debounced]);

    const handleChange = (e) => {
        const v = e?.target?.value ?? e;
        if (!isControlled) setValue(v);
        if (typeof onChange === "function") onChange(v);
    };

    const handleClear = () => {
        if (!isControlled) setValue("");
        if (typeof onChange === "function") onChange("");
        if (typeof onSearch === "function") onSearch("");
    };

    const handleSubmit = (e) => {
        e?.preventDefault();
        if (typeof onSearch === "function") onSearch(value);
    };

    return (
        <HrnbContainer className={className}>
            <HrnbRow style={{ alignItems: "center", gap: 8 }}>
                <HrnbCol>
                    <form onSubmit={handleSubmit} style={{ display: "flex", gap: 8 }}>
                        <HrnbInput
                            type="search"
                            placeholder={placeholder}
                            value={value}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") handleSubmit(e);
                            }}
                            aria-label="search"
                        />
                        <HrnbButton type="submit" icon={<SearchIcon />} variant="primary">
                            {buttonText}
                        </HrnbButton>

                        {showClear && (
                            <HrnbButton
                                type="button"
                                variant="secondary"
                                onClick={handleClear}
                                icon={<ClearIcon />}
                                title="Очистить"
                            />
                        )}
                    </form>
                </HrnbCol>
            </HrnbRow>
        </HrnbContainer>
    );
}

HrnbSearch.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    placeholder: PropTypes.string,
    debounceMs: PropTypes.number,
    showClear: PropTypes.bool,
    buttonText: PropTypes.string,
    className: PropTypes.string,
};

HrnbSearch.defaultProps = {
    value: undefined,
    onChange: undefined,
    onSearch: undefined,
    placeholder: "Поиск...",
    debounceMs: 300,
    showClear: true,
    buttonText: "Найти",
    className: "",
};
